module.exports = __webpack_public_path__ + "img/97.378568b7.jpg";